import { Exclude, Expose } from 'class-transformer';
import { IsInt, Max } from 'class-validator';

import { BaseModel } from '@core/data-access';

import { FlattenObject } from '../util';

@Exclude()
export class RemainingDate extends BaseModel {
  @Expose()
  @FlattenObject('value')
  @IsInt()
  @Max(99)
  years!: number;

  @Expose()
  @FlattenObject('value')
  @IsInt()
  @Max(99)
  months!: number;
}
